// Accent the "NN" in the Frannkly Roasted text logo — the nn is Anna & Frank, the
// meaning of the name (safe DOM construction, no innerHTML).
(function () {
  function brandify() {
    document.querySelectorAll('.header-logo').forEach(function (logo) {
      if (logo.dataset.brandified === '1') return;
      if (logo.querySelector('img')) { logo.dataset.brandified = '1'; return; } // image logo, skip
      var leaf = Array.prototype.find.call(
        logo.querySelectorAll('*'),
        function (el) { return el.children.length === 0 && /FRANNKLY/i.test(el.textContent); }
      ) || logo;
      var text = leaf.textContent;
      var idx = text.toUpperCase().indexOf('NN');
      if (idx === -1) return;
      leaf.textContent = '';
      leaf.appendChild(document.createTextNode(text.slice(0, idx)));
      var span = document.createElement('span');
      span.className = 'frannkly-ly';
      span.textContent = text.slice(idx, idx + 2);
      leaf.appendChild(span);
      leaf.appendChild(document.createTextNode(text.slice(idx + 2)));
      logo.dataset.brandified = '1';
    });
  }

  if (document.readyState !== 'loading') brandify();
  document.addEventListener('DOMContentLoaded', brandify);
  // Header can re-render (sticky / section reload in the editor) — retry a few times.
  var tries = 0;
  var iv = setInterval(function () { brandify(); if (++tries > 8) clearInterval(iv); }, 400);
})();
